import { Suspense, useContext, useState } from "react";
import { Button, Form, Row, Col, FloatingLabel, Spinner } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { UserLoginRequest } from "../../models/user";
import { LoginStore } from "../../stores/LoginStore";
import _ from 'lodash';
import AuthContext from "../../services/auth/authContext";
import { TFunction } from "i18next";

type Props = {
    t: TFunction;
    store: LoginStore;
}

const LoginForm: React.FC<Props> = ({ t, store }: Props) => {
    const { register, handleSubmit, formState: {errors}} = useForm();
    const [isLoading, setLoading] = useState(false);
    const authContext = useContext(AuthContext);
    const userLogin = async (data: UserLoginRequest) => {
        setLoading(true);
        await store.userLogin(data);
        authContext.updateAccessToken(store.accessToken);
        setLoading(false);
    }

    return (   
        <Suspense>
        <form className="login-form" onSubmit={handleSubmit((data) => userLogin(data as UserLoginRequest))}>
            <h3 className="text-center mb-3 gradient-title">{t("formTitle")}</h3>
            <FloatingLabel
                label="USERNAME"
                className="mb-3"
            >
                <>
                <Form.Control 
                    {...register('username', {
                        required: "Inserire una email o username validi",
                        // pattern: {
                        //     value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                        //     message: "Email/Username non valida"
                        // }
                    })}
                    name="username"
                    type="text"
                    placeholder="Enter username" 
                    autoComplete="username"  
                />
                <p className="form-error">{_.toString(errors.username?.message)}</p>
                </>
            </FloatingLabel>   
            <FloatingLabel
                label="PASSWORD"
                className="mb-3"
            >
                <>
                <Form.Control 
                    {...register('password', {
                        required: "Inserire una password"
                    })}
                    name="password"
                    type="password" 
                    placeholder="Password"
                    autoComplete="current-password" 
                />
                <p className="form-error">{errors.password?.message as String}</p>
                </>
            </FloatingLabel>
            <Row className="mt-4 justify-content-center">
                <Col md={6} className="text-center px-3 mb-1">
                    <p className="error-login">{store.accessMessage}</p>
                    <Button variant="primary" type="submit" className="w-100" disabled={isLoading}>
                        {isLoading && <Spinner animation="grow" size="sm" />} {t("enter")}
                    </Button>
                </Col>
            </Row>
        </form>
        </Suspense>
    );
}

export default LoginForm;